import { controlsHandler } from './functions';

export const plyrConfig = (attributes) => {
	const { controls, repeat, autoplay, muted, resetOnEnd, autoHideControl } = attributes;

	return {
		controls: controlsHandler(controls),
		clickToPlay: false,
		loop: { active: repeat },
		muted,
		autoplay,
		storage: !muted,
		resetOnEnd,
		hideControls: autoHideControl
	}
}